/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { HistoricalRedemption } from './historicalRedemption';
import { isNilOrEmpty } from '../../../language/module';
import * as R from 'ramda';
import { formatDate } from '../../../language/time';
import { MediumText } from '../../../styles/styles';
import { getResource } from '../../../language/resources/getResource';
import { IAppState } from '../../../core/redux/IAppState';
import { useSelector } from 'react-redux';


const Entry = styled('span')`
  ${MediumText};
  color: white;
  padding: 15px 10px;
  text-align: center;
  white-space:nowrap;
`;

const compareRedemptionDate = (a: HistoricalRedemption, b: HistoricalRedemption) =>
  new Date(a.redeemDate) > new Date(b.redeemDate) ? 1 : -1;

/**
 * RedemptionHistory: a component that shows a guest's previous entitlement redemptions in a nice little table.
 * Table includes info such as when an entitlement was redeemed, where it was redeemed, and how many of it was redeemed.
 */
export const RedemptionHistory: React.FC<{
  history?: HistoricalRedemption[];
  className?: SerializedStyles;
}> = ({ history, className }) => {
  const resources = useSelector((state: IAppState) => state.locale);
  const dateFormat = useSelector((state: IAppState) => state.defaultDateFormat);

  return(
  <table css={className}>
    <thead>
      {
        !isNilOrEmpty(history) && history!.length > 10 && <tr>
          <th colSpan={3} css={css`text-align: left;`}>
            <Entry>
              {getResource(resources, 'REDEMPTION_HISTORY_LABEL')}
            </Entry>
          </th>
        </tr>
      }
    {
      !isNilOrEmpty(history) && <tr>
        <th><Entry>{getResource(resources, 'REDEMPTION_HISTORY_DATE')}</Entry></th>
        <th><Entry>{getResource(resources, 'REDEMPTION_HISTORY_RESORT')}</Entry></th>
        <th><Entry>#</Entry></th>
        <th><Entry>{getResource(resources, 'REDEMPTION_HISTORY_REF_ID')}</Entry></th>
      </tr>
    }
    </thead>
    <tbody>
    {
      !isNilOrEmpty(history) && R.takeLast(10, history!).sort(compareRedemptionDate).map(item => (
        <tr key={item.redemptionID}>
          <td><Entry>{formatDate(item.redeemDate, dateFormat)}</Entry></td>
          <td><Entry>{item.redeemResort}</Entry></td>
          <td><Entry>{item.redeemQuantity}</Entry></td>
          <td><Entry>{item.redemptionExternalCode}</Entry></td>
        </tr>
      ))
    }
    {
      isNilOrEmpty(history) && <tr>
        <td css={css`text-align: left;`}><Entry css={css`text-align: left;`}>{getResource(resources, 'REDEMPTION_HISTORY_NO_HISTORY')}</Entry></td>
      </tr>
    }
    </tbody>
  </table>
  )
  };
